module.exports = __webpack_public_path__ + "static/quy-6fdd0d067d9b4458c0c22827bb0f4d4a.jpeg";